import { DynamicFlag, isFlagCode } from "@sankyu/react-circle-flags";
import { memo } from "react";
import { Flex } from "../../flex";
import * as css from "./flag.module.css";

const FLAG_SIZE_PX = { xxs: 8, xs: 12, sm: 16, md: 20, lg: 24 } as const;

export type FlagSize = keyof typeof FLAG_SIZE_PX;

/**
 * Circular country/region flag. Pass an ISO 3166-1 alpha-2 code (e.g. "US",
 * "GB") in any casing; unsupported codes render nothing so callers can drop it
 * in next to a country label without guarding.
 */
export const Flag = memo(function Flag({
  countryCode,
  alt,
  size = "md",
  uiSelector,
}: {
  countryCode: string;
  alt?: string;
  size?: FlagSize;
  uiSelector?: string;
}) {
  const code = countryCode.toLowerCase();
  if (!isFlagCode(code)) {
    return null;
  }
  const px = FLAG_SIZE_PX[size];
  return (
    <Flex
      align="center"
      className={css[size]}
      data-ui={uiSelector}
      justify="center"
      overflow="hidden"
      radius="full"
      shrink={0}
    >
      <DynamicFlag
        code={code}
        height={px}
        title={alt ?? countryCode.toUpperCase()}
        width={px}
      />
    </Flex>
  );
});
